import { CampaignContent } from '@tm/client-form/src/components/campaign/CampaignContent'
import { useI18N } from '@tm/client-form/src/hooks/useI18n'
import { ContentField } from '@tm/shared-lib/src/field'

type ContentInputProps = {
  field: ContentField
  lang: string
}

export function ContentInput({ field, lang }: ContentInputProps) {
  const { tt } = useI18N()
  if (!field.content) return null
  const content = tt(field.content)
  return <CampaignContent content={content} />
}
